import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { HeroScreen } from './components/HeroScreen';
import { EpisodeNavScreen } from './components/EpisodeNavScreen';
import { EpisodeViewScreen } from './components/EpisodeViewScreen';
import { Episode2NavScreen } from './components/Episode2NavScreen';
type Screen = 'hero' | 'episode-nav' | 'episode-view' | 'episode-2-nav';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('hero');
  return <main className="bg-[var(--bg-primary)] min-h-screen w-full text-[var(--text-primary)] overflow-x-hidden selection:bg-[var(--accent)] selection:text-white" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {currentScreen === 'hero' && <HeroScreen key="hero" onStart={() => setCurrentScreen('episode-nav')} data-id="element-2" />}

        {currentScreen === 'episode-nav' && <EpisodeNavScreen key="episode-nav" onPlay={() => setCurrentScreen('episode-view')} onBack={() => setCurrentScreen('hero')} onNextEpisode={() => setCurrentScreen('episode-2-nav')} data-id="element-3" />}

        {currentScreen === 'episode-view' && <EpisodeViewScreen key="episode-view" onBack={() => setCurrentScreen('episode-nav')} data-id="element-4" />}

        {currentScreen === 'episode-2-nav' && <Episode2NavScreen key="episode-2-nav" onBack={() => setCurrentScreen('episode-nav')} data-id="element-5" />}
      </AnimatePresence>
    </main>;
}